import * as THREE from 'three'
import Experience from './Experience.js'

export default class Renderer
{
    constructor()
    {
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.camera = this.experience.camera
        this.debug = this.experience.debug

        this.params = {
            backgroundColorLight: '#e5e7eb',
            backgroundColorDark: '#1b1c1d',
        }

        this.setRenderer()
    }

    setRenderer()
    {
        this.renderer = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            alpha: true,
        })
        this.renderer.sortObjects = false;
        this.renderer.setClearColor(this.params.backgroundColorLight);
        this.renderer.physicallyCorrectLights = true
        this.renderer.outputEncoding = THREE.sRGBEncoding
        this.renderer.toneMapping = THREE.NoToneMapping
        this.renderer.toneMappingExposure = 1.75
        this.renderer.shadowMap.enabled = true
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap
        this.renderer.setSize(this.sizes.width, this.sizes.height)
        this.renderer.setPixelRatio(Math.min(this.sizes.pixelRatio, 2))

        //Debug
        if(this.debug.active)
        {
            this.backgroundDebugFolder = this.debug.ui.addFolder('background');
            this.backgroundDebugFolder.close();
            this.backgroundDebugFolder.addColor(this.params, 'backgroundColorLight').name('backgroundColor').onChange(() =>
            {
                (this.renderer.setClearColor(this.params.backgroundColorLight));
            });
        }
    }

    resize()
    {
        this.renderer.setSize(this.sizes.width, this.sizes.height)
        this.renderer.setPixelRatio(Math.min(this.sizes.pixelRatio, 2))
    }

    update()
    {
        this.renderer.render(this.scene, this.camera.camera)
    }
}